import { AlertTriangle } from 'lucide-react'

export default function PlaceholderBanner({ children }) {
  return (
    <div
      role="alert"
      className="sticky top-16 lg:top-20 z-30 bg-amber-400 text-void-950 border-b-4 border-amber-600 shadow-lg"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-start gap-3">
        <AlertTriangle className="w-6 h-6 shrink-0 mt-0.5" strokeWidth={2.5} />
        <p className="text-sm sm:text-base font-semibold leading-snug">
          {children}
        </p>
      </div>
    </div>
  )
}
